import { render, staticRenderFns } from "./ViResetPassword.vue?vue&type=template&id=11786e3c&scoped=true"
import script from "./ViResetPassword.vue?vue&type=script&lang=js"
export * from "./ViResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ViResetPassword.vue?vue&type=style&index=0&id=11786e3c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11786e3c",
  null
  
)

export default component.exports